export default __webpack_public_path__ + "static/media/Artboard 13.ee86b249.png";